export default __webpack_public_path__ + "static/color-emphasis-levels-status-light-8f91d5df4c65aa3cdef47ef8a08afd4a.png";